import FJButton, { FJButtonType } from '../FJButton/FJButton';
import FJResourcePanel from '../FJResourcePanel/FJResourcePanel';
import styles from './FJSidePhotoListPanel.module.less';
import PropTypes from 'prop-types';
import FJConstant from '../../../constants/FJConstant';
import { useCallback } from 'react';
import FJHoverBoardGradation from '../FJHoverBoard/FJHoverBoardGradation';
import classNames from 'classnames';
import FJLoading from '../FJLoading/FJLoading';
import FJSourcePreviewItem from '../../../components/FJMainPreview/FJSourcePreviewItem/FJSourcePreviewItem';

const FJSidePhotoListPanel = props => {
    const {
        list,
        sizeList,
        status,
        curSelectKey,

        loadingList = [], // 加载中列表

        className,
        scrollerClassName,

        // historyType
        historyType, // 显示的 历史 Ai工具类型 为空则是非AI工具生成历史

        isShowBottom = true,

        btn1Text = 'cancel',
        btn1Click,
        btn1Disabled = false,

        btn2Text = 'upload',
        btn2Icon,
        btn2ClassName,
        btn2Click,
        btn2Disabled = false,

        itemClick,
        onClickRetry,
        renderBottom = () => {},
    } = props;

    const renderItem = useCallback(
        (itemRect, item, index) => {
            const key = item.id || item.name;
            const active = curSelectKey ? key === curSelectKey || key === curSelectKey : false;
            return (
                <FJHoverBoardGradation
                    className={styles.item}
                    style={itemRect}
                    borderRadius={6}
                    key={key}
                    hasHover={!active}
                    isShowInBorder={true}
                    active={active}
                >
                    <FJSourcePreviewItem
                        item={item}
                        hideDelete={true}
                        hideDownload={true}
                        hideSelect={true}
                        appType={historyType}
                        onClick={() => itemClick(item)}
                    />

                    {loadingList.find(i => i.key === key) !== undefined && <FJLoading className={styles.loading} />}
                </FJHoverBoardGradation>
            );
        },
        [curSelectKey, itemClick, loadingList],
    );

    return (
        <div className={classNames(styles.panel, { [styles.pb_70]: isShowBottom }, className)}>
            <FJResourcePanel
                list={list}
                sizeList={sizeList}
                className={styles.resource_panel}
                scrollerClassName={classNames(styles.virtualized_mix_view, scrollerClassName)}
                renderItem={renderItem}
                isShowLoading={status === FJConstant.LOADING}
                isShowError={status === FJConstant.ERROR}
                isShowEmpty={list.length === 0 && status !== FJConstant.LOADING && status !== FJConstant.ERROR}
                historyType={historyType}
                onClickRetry={onClickRetry}
            />

            {isShowBottom && (
                <div className={styles.bottom_box}>
                    <FJButton
                        disabled={btn1Disabled}
                        text={btn1Text}
                        className={styles.cancel_btn}
                        textClassName={styles.upload_btn_text}
                        onClick={btn1Click}
                    />
                    <FJButton
                        disabled={btn2Disabled}
                        type={FJButtonType.GRADIENT}
                        text={btn2Text}
                        className={classNames(styles.upload_btn, btn2ClassName)}
                        icon={btn2Icon}
                        onClick={btn2Click}
                        textClassName={styles.upload_btn_text}
                    />
                </div>
            )}
            {status === FJConstant.SUCCESS && list.length > 0 && renderBottom()}
        </div>
    );
};

FJSidePhotoListPanel.propTypes = {
    list: PropTypes.array,
    sizeList: PropTypes.array,
    renderItem: PropTypes.func,
    flexClipBgLoadStatus: PropTypes.string,
    onClickRetry: PropTypes.func,
    btn2ClassName: PropTypes.string,
};

export default FJSidePhotoListPanel;
